import { Observable } from 'rxjs';

import { UseCase } from '../../base/use-case';

import { DataTypeResourceModel, TypeResourceModel } from '../../models/academy/type-resource.model';

import { AcademyRepository } from '../../repositories/academy.repository';

export class UpdatetyperesourceUseCase implements UseCase<
  DataTypeResourceModel,
  TypeResourceModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(params:DataTypeResourceModel): Observable<TypeResourceModel> {
    return this.repository.updateTypeResource(params);
  }
}
